import React,{useState,useEffect} from "react";
import { DataTablePagerModel } from "../../models";
import { useTranslation } from "react-i18next";
import { getLabelName } from "../../utils";

export const DataTablePager: React.FC<DataTablePagerModel> = ({
  currentPage,
  rowsPerPage,
  totalRows,
  rowsPerPageOptions,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const totalPages = Math.ceil(totalRows / rowsPerPage); // Total number of pages
  const { i18n } = useTranslation(); // Use translation hook

  // Detect if the current language is Arabic (or other RTL languages)
  const isRTL =
    i18n.language === "ar" ||
    i18n.language === "he" ||
    i18n.language === "ar-AE";

  // ==== Detect mobile screen =====>
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // CSS-in-JS styles
  const styles = {
    paginationContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: isMobile ? "4px":"8px",
      padding: "10px",
      flexWrap:"wrap" as const,
    },
    paginationButton: {
      background: "none",
      color: "#333",
      fontSize: isMobile ? "14px" : "16px",
      cursor: "pointer",
      border: "1px solid #ccc",
      padding: isMobile ? "4px 4px" : "6px 10px",
      borderRadius: "4px",
      minWidth:isMobile ? "40px": "80px",
    },
    paginationButtonDisabled: {
      color: "#d3d3d3",
      cursor: "not-allowed",
    },
    paginationInfo: {
      margin: isMobile ? "0 6px" : "0 10px",
      fontSize: "14px",
      fontWeight: isMobile ? "550" :"700",
      minWidth: isMobile ? "45px" :"auto",
      textAlign:"center" as const,

    },
    paginationSelect: {
      marginLeft: isMobile ? "7px" :"10px",
      padding: "4px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      minWidth: isMobile ?"40px":"60px",
    },
  };


  return (
    <div style={styles.paginationContainer}>
      {/* First page button */}
      <button
        style={
          currentPage === 1
            ? { ...styles.paginationButton, ...styles.paginationButtonDisabled }
            : styles.paginationButton
        }
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      >
        {/*{"|<<"}*/}
        {getLabelName(isMobile ? "<<" : "first Page")}
      </button>

      {/* Previous page button */}
      <button
        style={
          currentPage === 1
            ? { ...styles.paginationButton, ...styles.paginationButtonDisabled }
            : styles.paginationButton
        }
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        {/*{"<"}*/}
        {getLabelName(isMobile ? "<" : "previous Page")}
      </button>

      {/* Display current page number / total pages */}
      <span style={styles.paginationInfo}>
        {isRTL
          ? `${totalPages} / ${currentPage}`
          : `${currentPage} / ${totalPages}`}
      </span>

      {/* Next page button */}
      <button
        style={
          currentPage === totalPages
            ? { ...styles.paginationButton, ...styles.paginationButtonDisabled }
            : styles.paginationButton
        }
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        {/*{">"}*/}
        {getLabelName(isMobile ? ">" : " next Page")}
      </button>

      {/* Last page button */}
      <button
        style={
          currentPage === totalPages
            ? { ...styles.paginationButton, ...styles.paginationButtonDisabled }
            : styles.paginationButton
        }
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        {/*{">>|"}*/}
        {getLabelName(isMobile ? ">>" : "last Page")}
      </button>

      {/* Rows per page select */}
      <select
        style={styles.paginationSelect}
        value={rowsPerPage}
        onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
      >
        {rowsPerPageOptions.map((size) => (
          <option key={size} value={size}>
            {size}
          </option>
        ))}
      </select>
    </div>
  );
};






// import React from "react";
// import { DataTablePagerModel } from "../../models";
// import { useTranslation } from "react-i18next";
// import { getLabelName } from "../../utils";

// export const DataTablePager: React.FC<DataTablePagerModel> = ({
//   currentPage,
//   rowsPerPage,
//   totalRows,
//   rowsPerPageOptions,
//   onPageChange,
//   onRowsPerPageChange,
// }) => {
//   const totalPages = Math.ceil(totalRows / rowsPerPage); // Total number of pages
//   const { i18n } = useTranslation(); // Use translation hook

//   // Detect if the current language is Arabic (or other RTL languages)
//   const isRTL =
//     i18n.language === "ar" ||
//     i18n.language === "he" ||
//     i18n.language === "ar-AE";

//   // CSS-in-JS styles
//   const styles = {
//     paginationContainer: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       gap: "8px",
//       // ==== Add Css ====> //
//       // flexWrap: "wrap",
//       padding: "10px",
//       width: "100%",
//     },
//     paginationButton: {
//       background: "none",
//       // border: "none",
//       color: "#333",
//       fontSize: "16px",
//       cursor: "pointer",
//       // padding: "5px",
//       // ==== Add Css ====> //
//       border: "1px solid #ccc",
//       padding: "6px 10px",
//       borderRadius: "4px",
//       minWidth: "80px",
//     },
//     paginationButtonDisabled: {
//       color: "#d3d3d3",
//       cursor: "not-allowed",
//     },
//     paginationInfo: {
//       margin: "0 10px",
//       fontSize: "14px",
//       // ==== Add Css ====> //
//       fontWeight: "700",
//     },
//     paginationSelect: {
//       marginLeft: "10px",
//       padding: "4px",
//       border: "1px solid #ccc",
//       borderRadius: "4px",
//       minWidth: "60px",
//     },
//     // Responsive Styles
//     "@media (max-width: 600px)": {
//       paginationContainer: {
//         flexDirection: "column",
//         gap: "5px",
//       },
//       paginationButton: {
//         fontSize: "12px",
//         padding: "4px 8px",
//         minWidth: "60px",
//         backgroundColor:"#333"
//       },
//       paginationInfo: {
//         fontSize: "12px",
//       },
//       paginationSelect: {
//         minWidth: "50px",
//       },
//     },
//   };

//   // Responsive adjustments
//   // const responsiveStyles = {
//   //     "@media (max-width: 600px)": {
//   //         paginationContainer: {
//   //             flexDirection: "column",
//   //             gap: "5px",
//   //         },
//   //         paginationButton: {
//   //             fontSize: "12px",
//   //             padding: "4px 8px",
//   //             minWidth: "60px",
//   //         },
//   //         paginationInfo: {
//   //             fontSize: "12px",
//   //         },
//   //         paginationSelect: {
//   //             minWidth: "50px",
//   //         },
//   //     },
//   // };

//   return (
//     <div style={styles.paginationContainer}>
//       {/* First page button */}
//       <button
//         style={
//           currentPage === 1
//             ? { ...styles.paginationButton, ...styles.paginationButtonDisabled }
//             : styles.paginationButton
//         }
//         onClick={() => onPageChange(1)}
//         disabled={currentPage === 1}
//       >
//         {/*{"|<<"}*/}
//         {getLabelName("first Page")}
//       </button>

//       {/* Previous page button */}
//       <button
//         style={
//           currentPage === 1
//             ? { ...styles.paginationButton, ...styles.paginationButtonDisabled }
//             : styles.paginationButton
//         }
//         onClick={() => onPageChange(currentPage - 1)}
//         disabled={currentPage === 1}
//       >
//         {/*{"<"}*/}
//         {getLabelName("previous Page")}
//       </button>

//       {/* Display current page number / total pages */}
//       <span style={styles.paginationInfo}>
//         {isRTL
//           ? `${totalPages} / ${currentPage}`
//           : `${currentPage} / ${totalPages}`}
//       </span>

//       {/* Next page button */}
//       <button
//         style={
//           currentPage === totalPages
//             ? { ...styles.paginationButton, ...styles.paginationButtonDisabled }
//             : styles.paginationButton
//         }
//         onClick={() => onPageChange(currentPage + 1)}
//         disabled={currentPage === totalPages}
//       >
//         {/*{">"}*/}
//         {getLabelName(" next Page")}
//       </button>

//       {/* Last page button */}
//       <button
//         style={
//           currentPage === totalPages
//             ? { ...styles.paginationButton, ...styles.paginationButtonDisabled }
//             : styles.paginationButton
//         }
//         onClick={() => onPageChange(totalPages)}
//         disabled={currentPage === totalPages}
//       >
//         {/*{">>|"}*/}
//         {getLabelName("last Page")}
//       </button>

//       {/* Rows per page select */}
//       <select
//         style={styles.paginationSelect}
//         value={rowsPerPage}
//         onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
//       >
//         {rowsPerPageOptions.map((size) => (
//           <option key={size} value={size}>
//             {size}
//           </option>
//         ))}
//       </select>
//     </div>
//   );
// };
